import Error from "next/error";
import { ContextProvider } from "../../../../components/context-provider";
import Layout from "../../../../components/layout";
import getSSRProps from "./services";
import { log } from "../../../../lib/utils/commons";
import BodyContent from "../../../../components/BodyContent";
import getRawBody from "raw-body";

const getErrorBlanket = (statusCode) => {
  return <Error statusCode={statusCode} />;
};

// A react component cannot return as a promise so you don't place the async on this function
const OrchPost = ({
  blocks,
  metaData,
  externalData,
  statusCode,
  logTrace,
  urlParamsProps
}) => {
  logTrace += `;STATUS=${statusCode}`;
  log.info(`${logTrace};EVENT_NAME=EVENT_RENDER_POST_INITIATED`);
  let err;

  if (statusCode !== 200) {
    err = getErrorBlanket(statusCode);
  }

  const event_name = err
    ? "EVENT_RENDER_POST_ERROR"
    : "EVENT_RENDER_POST_COMPLETED";
  log.info(`${logTrace};EVENT_NAME=${event_name}`);

  return (
    <Layout metaData={metaData}>
      <ContextProvider metaData={metaData}>
        <BodyContent
          blocks={blocks}
          externalData={externalData}
          logTrace={logTrace}
          err={err}
          metaData={metaData}
          urlParamsProps={urlParamsProps}
        />
      </ContextProvider>
    </Layout>
  );
};

// This is a NextJS extension of functional components
// Here we can get all info that we want passed into the component via props
export async function getServerSideProps({ query, req, res }) {

  const isOrchestration = true;
  const { casid } = query;
  const body = await getRawBody(req);
  const intuit_tid = req.headers["intuit_tid"] || "";
  // Upstream (weborchestrator) sends the full payload for /page/render/pageContent/*,
  // so CAS does not need to be called again. Log the received payload size for observability.
  log.info(
    `INTUIT_TID=${intuit_tid};EVENT_NAME=ORCH_PAYLOAD_SIZE_LOGGED;PAYLOAD_SIZE_BYTES=${
      body ? body.length : 0
    }`
  );
  let postBody = {};
  try {
    postBody = body ? JSON.parse(body?.toString("utf-8")) : {};
  } catch (jsonparseerror) {
    // in case of any json parsing error, default to blank JSON
    log.error(
      `{error : "${jsonparseerror}", query : "${query}", event : "POSTBODY_JSON_PARSE_ERROR_DEFAULTING_TO_{}"}`
    );
    postBody = {};
  }
  return getSSRProps({ query, req, res }, isOrchestration, postBody, casid);
}

export default OrchPost;
